// import React, { useEffect, useState } from 'react'

// export const useGetPosition = (
//   ref: React.MutableRefObject<HTMLDivElement | null> | null,
//   active: boolean,
// ): { left: number; top: number } => {
//   const [position, setPosition] = useState({ left: 0, top: 0 })

//   const getPosition = () => {
//     if (ref?.current) {
//       const { left, top } = ref.current.getBoundingClientRect()
//       setPosition({ left, top })
//     }
//   }

//   useEffect(() => {
//     const scrollWrapper = document.getElementsByClassName(
//       'app-scroll-wrap main-scroll',
//     )[0]
//     if (active && scrollWrapper) {
//       getPosition()
//       scrollWrapper.addEventListener('resize', getPosition, false)
//       scrollWrapper.addEventListener('scroll', getPosition, false)
//     }
//     return () => {
//       if (active && scrollWrapper) {
//         scrollWrapper.removeEventListener('resize', getPosition, false)
//         scrollWrapper.removeEventListener('scroll', getPosition, false)
//       }
//     }
//   }, [active])

//   return position
// }
import React, { useCallback, useEffect, useState } from 'react'

export const useGetPosition = (
  ref: React.MutableRefObject<HTMLDivElement | null> | null,
  active: boolean,
): { left: number; top: number; width: number; height: number } => {
  const [position, setPosition] = useState({
    left: 0,
    top: 0,
    width: 0,
    height: 0,
  })

  const getPosition = useCallback(() => {
    if (ref?.current) {
      const { left, top, width, height } = ref.current.getBoundingClientRect()
      setPosition({ left, top, width, height })
    }
  }, [ref])

  useEffect(() => {
    if (active) {
      getPosition()
      const element = document.querySelector('.main-scroll')
      if (element) {
        element.addEventListener('resize', getPosition, false)
        element.addEventListener('scroll', getPosition, false)
      } else {
        window.addEventListener('resize', getPosition, false)
        window.addEventListener('scroll', getPosition, false)
      }
    }
    return () => {
      if (active) {
        const element = document.querySelector('.main-scroll')
        if (element) {
          element.removeEventListener('resize', getPosition, false)
          element.removeEventListener('scroll', getPosition, false)
        } else {
          window.removeEventListener('resize', getPosition, false)
          window.removeEventListener('scroll', getPosition, false)
        }
        window.removeEventListener('resize', getPosition, false)
        window.removeEventListener('scroll', getPosition, false)
      }
    }
  }, [active, getPosition])

  return position
}
